import { render } from "./ProjectCreator.vue?vue&type=template&id=68208438&scoped=true"
import script from "./ProjectCreator.vue?vue&type=script&lang=js"
export * from "./ProjectCreator.vue?vue&type=script&lang=js"

import "./ProjectCreator.vue?vue&type=style&index=0&id=68208438&scoped=true&lang=css"

import exportComponent from "/working_dir/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68208438"]])

export default __exports__